import styled from "styled-components";

import { DATA_E2E_KEY, type IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, greyMui, rydeColors } from "@ryde/theme";

export const PrintRidesWrapperStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bulk-print-rides-wrapper",
})`
  page-break-after: always;
`;

export const PrintRidesHeaderStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bulk-print-rides-header",
})`
  display: flex;
  flex-direction: row;
  padding: 26px 40px;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);
  font-size: 16px;
  color: ${rydeColors.black};
  justify-content: space-between;
  align-items: center;

  div {
    display: flex;
    flex-direction: row;
    gap: 10px;

    .ride-number {
      font-weight: 700;
    }

    .site-name {
      font-weight: 400;
    }
  }
`;

export const PrintRidesBodyStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bulk-print-rides-body",
})`
  padding: 20px 30px;
  font-size: 12px;
  color: ${rydeColors.black};

  .label {
    font-weight: 400;
    color: ${blueGreyMui._500};
  }

  .bold {
    font-weight: 600;
  }

  .info-block {
    padding: 0 10px 24px;
    display: grid;
    grid-template-columns: 4fr 1fr;
    gap: 10px;

    .info-column {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }

  .table-block {
    .table-header {
      padding: 10px 10px 8px;
      display: grid;
      grid-template-columns: 25fr 10fr 7fr 20fr 40fr;
      background: ${rydeColors.bulkPrintHeader};
    }

    .table-body {
      .table-body-block {
        padding: 10px;
        display: grid;
        grid-template-columns: 25fr 10fr 7fr 20fr 40fr;

        .passenger-list {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        .unit-list {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        .pickup-dropoff-list {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        &:not(:last-child) {
          border-bottom: 1px solid ${greyMui._300};
        }
      }
    }
  }

  .custom-fields-block {
    padding: 16px 10px 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
    border-top: 1px solid ${greyMui._300};

    & > div {
      break-inside: avoid;
    }

    .field-value {
      white-space: pre-wrap;
      overflow-wrap: anywhere;
    }
  }
`;

export const PrintRidesFlexBlock = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bulk-print-flex-block",
})`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;
